(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dl-length-note"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__dlLength) return;
    window.__dlLength = true;

    function unit() {
      var el = document.querySelector('[data-dl-unit]');
      return el ? el.getAttribute('data-dl-unit') : null;
    }

    function fix(node) {
      var u = unit();
      if (!u) return;
      var text = node.textContent || '';
      var re = /(\d+(?:\.\d+)?)\s?cm\s?\/\s?(\d+(?:\.\d+)?)\s?in\b/gi;
      if (!re.test(text)) return;
      var next = text.replace(re, function (m, cm, inch) { return u === 'in' ? inch + ' in' : cm + ' cm'; });
      if (next !== text) node.textContent = next;
    }

    function init() {
      document.querySelectorAll('.sticky-add-to-cart__variant').forEach(function (node) {
        if (node._dlLen) return;
        node._dlLen = true;
        fix(node);
        new MutationObserver(function () { fix(node); }).observe(node, { childList: true, characterData: true, subtree: true });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dl-sticky-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__dlStickyBar) return;
    window.__dlStickyBar = true;

    function unit() {
      var el = document.querySelector('[data-dl-sticky-unit]');
      var u = el && el.getAttribute('data-dl-sticky-unit');
      return u === 'in' || u === 'cm' ? u : null;
    }

    // "Black Gold / 3mm (0.1ct) / 17cm / 6.7in" -> "Black Gold · 6.7 in" (stone size and bare ring sizes left out)
    function tidy(text) {
      var u = unit();
      var t = text.replace(/\s+/g, ' ').trim();
      t = t.replace(/(\d+(?:\.\d+)?)\s?cm\s?\/\s?(\d+(?:\.\d+)?)\s?in\b/gi, function (m, cm, inch) {
        return u === 'cm' ? cm + ' cm' : inch + ' in';
      });
      return t
        .split(/\s*\/\s*/)
        .map(function (part) {
          var m = part.match(/^(.*?)(\d[\d.\-]*)"\s*\((\d[\d.\-\s]*)cm\)$/);
          if (!m) return part;
          return (m[1] + (u === 'cm' ? m[3].replace(/\s/g, '') + ' cm' : m[2] + ' in')).trim();
        })
        .filter(function (part) {
          return part && !/\d\s?(x\s?\d+(\.\d+)?\s?)?mm\b|\bct\b|^\d+(\.\d+)?$/i.test(part);
        })
        .join(' · ');
    }

    function fix(node) {
      var current = node.textContent.replace(/\s+/g, ' ').trim();
      if (!current || node.getAttribute('data-dl-tidy') === current) return;
      var next = tidy(current);
      node.setAttribute('data-dl-tidy', next);
      if (next !== current) node.textContent = next;
    }

    function init() {
      document.querySelectorAll('.sticky-add-to-cart__variant').forEach(function (node) {
        if (node._dlTidy) return;
        node._dlTidy = true;
        fix(node);
        new MutationObserver(function () { fix(node); }).observe(node, { childList: true, characterData: true, subtree: true });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  /* v16 · Phones: show the bar from the first screen, before the main button is reached.
     Ring sizes: until a size is tapped, the bar button reads "Select size" and scrolls to the sizes
     instead of adding the preselected size. Horizon still handles the bar once the main button is passed. */
  (function () {
    if (window.__dlStickyEarly) return;
    window.__dlStickyEarly = true;

    var phone = window.matchMedia('(max-width: 989px)');
    var sizeChosen = false;

    function isSizeInput(el) {
      return el && el.matches && el.matches('variant-picker input[type="radio"]') && /ring\s*size/i.test((el.name || '').split('-')[0]);
    }

    function sizeInputs() {
      return Array.prototype.filter.call(document.querySelectorAll('variant-picker input[type="radio"]'), isSizeInput);
    }

    function needsSize() {
      return !sizeChosen && sizeInputs().length > 1;
    }

    function chatActive() {
      return !!customElements.get('shopify-chat') && !!document.querySelector('shopify-chat');
    }

    function syncLabel() {
      var sticky = document.querySelector('sticky-add-to-cart');
      if (sticky) sticky.classList.toggle('dl-needs-size', phone.matches && needsSize());
    }

    function init() {
      syncLabel();
      var sticky = document.querySelector('sticky-add-to-cart');
      if (!sticky || !('IntersectionObserver' in window)) return;
      var bar = sticky.querySelector('[ref="stickyBar"]');
      var form = document.querySelector('product-form-component[data-product-id="' + sticky.dataset.productId + '"]');
      var buy = form && form.closest('.buy-buttons-block');
      if (!bar || !buy) return;

      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry || !phone.matches) return;
        if (entry.isIntersecting) {
          bar.dataset.stuck = 'false';
        } else if (entry.boundingClientRect.top > 0 && !chatActive()) {
          bar.dataset.stuck = 'true';
        }
      }).observe(buy);
    }

    // Window capture runs before Horizon's delegated document listener, so the preselected size is never added by mistake.
    window.addEventListener('click', function (event) {
      var target = event.target;
      if (isSizeInput(target)) {
        sizeChosen = true;
        syncLabel();
        var prompt = target.closest('fieldset');
        if (prompt) prompt.classList.remove('dl-size-prompt');
        return;
      }
      var button = target && target.closest ? target.closest('sticky-add-to-cart .sticky-add-to-cart__button') : null;
      if (!button || !phone.matches || !needsSize()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var first = sizeInputs()[0];
      var fieldset = first && first.closest('fieldset');
      if (!fieldset) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      fieldset.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      fieldset.classList.remove('dl-size-prompt');
      void fieldset.offsetWidth;
      fieldset.classList.add('dl-size-prompt');
    }, true);

    if (phone.addEventListener) phone.addEventListener('change', syncLabel);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
